import RestaurantInvoicePaymentOneScreen from "./RestaurantInvoicePaymentOneScreen";

export default RestaurantInvoicePaymentOneScreen;
